<template>
  <v-app>
    <v-main class="text-center align-center">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "LoadingView",
};
</script>